<template>
  <div>
    <MtxModal :showing="message === 'web3'" @hide="clearLock">
      <div class="text-center">
        <h3>Web3 Required</h3>
        <p>
          Please install
          <a href="https://metamask.io/" target="_blank">MetaMask.</a>
        </p>
      </div>
    </MtxModal>
    <MtxModal :showing="message === 'account'" @hide="clearLock">
      <div class="text-center">
        <h3>Wallet Locked</h3>
        <p>
          In order to interact with the Matryx Platform, you must
          <br />
          unlock your wallet and approve the connection request
        </p>
        <button @click.stop="unlock" class="btn--link">Unlock</button>
      </div>
    </MtxModal>
    <MtxModal :showing="message === 'network'" @hide="clearLock">
      <div class="text-center">
        <h3>Wrong Network</h3>
        <p>Please switch to the {{ targetNetwork }} in MetaMask</p>
        <p v-if="frontendUrl">
          or visit
          <a :href="`https://${frontendUrl}`">{{ frontendUrl }}</a>
        </p>
      </div>
    </MtxModal>
    <MtxModal :showing="message === 'user'" @hide="clearLock">
      <div class="text-center">
        <h3>Sign In</h3>
        <p>Please sign in with MetaMask</p>
        <button @click.stop="login" class="btn--link">Sign In</button>
      </div>
    </MtxModal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

const NETWORK_ID = process.env.VUE_APP_NETWORK_ID || "3"
const networks = {
  1: "Main Ethereum Network",
  3: "Ropsten Test Network"
}

const frontends = {
  1: "app.matryx.ai",
  3: "ropsten.matryx.ai"
}

export default {
  computed: {
    ...mapState(["web3"]),

    message() {
      const { user } = this.$store.state
      let val = ""

      if (this.web3.lock.enabled) {
        if (!this.web3.available) {
          val = "web3"
        } else if (!this.web3.account) {
          val = "account"
        } else if (this.web3.network !== NETWORK_ID) {
          val = "network"
        } else if (!user.ethAddress) {
          val = "user"
        } else if (!user.email) {
          val = "kyc"
        }
      }

      return val
    },

    frontendUrl() {
      return frontends[this.web3.network]
    },

    targetNetwork() {
      return networks[NETWORK_ID]
    }
  },

  watch: {
    message: {
      handler(message) {
        if (message === "account") {
          this.unlock()
        } else if (message === "user") {
          this.login()
        } else if (message === "kyc") {
          this.clearLock()
          this.$router.push({ name: "Account Setup" })
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions(["checkWeb3", "clearLock", "login"]),

    async unlock() {
      await window.ethereum.enable()
      this.checkWeb3()
    }
  }
}
</script>
